import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

export const useDeepLinks = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listenerHandle: any = null;

    const addListener = async () => {
      listenerHandle = await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        const urlObj = new URL(event.url);
        const pathname = urlObj.pathname;
        const search = urlObj.search;
        const hash = urlObj.hash;

        if (pathname && pathname !== '/') {
          navigate(`${pathname}${search}${hash}`);
        }
      });
    };

    addListener();

    return () => {
      if (listenerHandle) {
        listenerHandle.remove();
      }
    };
  }, [navigate]);
};
